import React, { useEffect, useState, useRef, VFC, ChangeEvent, useContext } from 'react';
import Modal from 'react-bootstrap/Modal';
import './editProduct.scss';
import { useAuth } from '@/lib/auth';
import { City, Product, State } from '../types/indes';
import 'react-initials-avatar/lib/ReactInitialsAvatar.css';
import { useUpdateProduct } from '../api/updateProduct';
import { ModalFooter } from 'react-bootstrap';
import TagsInput from 'react-tagsinput';
import 'react-tagsinput/react-tagsinput.css'
import Delete from '@/assets/steam/delete.svg';
import AddWhiteIcon from '@/assets/steam/add-white.png';
import { showNotification } from '@/utils/notificationUtils';

const EditProduct: VFC<{
    onConfirm: () => void;
    onClose: () => void;
    open: boolean;
    states?: any;
    role?: any;
    editProductData?: any;
}> = ({ onClose, onConfirm, open, states, role, editProductData, }) => {
    const { user } = useAuth();
    const useProductUpdateMutations = useUpdateProduct();
    const subjectContainerRef = useRef<HTMLDivElement | null>(null);
    const [productData, setProductData] = useState<Product>({
        name: '',
        subject: [{
             name: '',
             classes: [],
           }]
    } as Product);

    useEffect(() => {
        if (editProductData) {

            setProductData({
                name: editProductData?.name,
                subject: editProductData?.subject
            } as Product)
        }

    }, [editProductData])


    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        if (event.target.id === 'name') {
            productData.name = event.target.value;
        }
        setProductData({ ...productData });
    };


    const resetStates = () => {
        setProductData({
            name: '',
            subject: [{
                 name: '',
                 classes: [],
               }]
        } as Product)

    }

    const handleSubjectChange = (e: React.ChangeEvent<HTMLInputElement>, subjectIndex: number) => {
        const updatedSubjects = [...productData.subject];
        updatedSubjects[subjectIndex].name = e.target.value;
        setProductData({ ...productData, subject: updatedSubjects });
    };

    const handleClassChange = (classes: string[], subjectIndex: number) => {
        const updatedSubjects = [...productData.subject];
        updatedSubjects[subjectIndex].classes = classes.map((className, index) => ({
            ...updatedSubjects[subjectIndex].classes[index],
            name: className,
        }));

        setProductData({ ...productData, subject: updatedSubjects });
    };

    const handleDeleteSubject = (subjectIndex: number) => {
        const updatedSubjects = productData.subject.filter(
          (_: any, index: number) => index !== subjectIndex
        );

      
        setProductData((prevData) => ({
          ...prevData,
          subject: updatedSubjects,
        }));
      };

    const handleAddSubject = () => {
        const newSubject: any = {
         // id: `${productData.subject.length + 1}`, // Generate a simple ID
          name: '',
          classes: [],
        };

            setProductData({
                ...productData,
                subject: [...productData.subject, newSubject],
              });
              setTimeout(() => {
                subjectContainerRef.current?.scrollIntoView({ behavior: 'smooth', block: 'end' });
              }, 100);
      };

    const getContent = () => {
        return (
            <div className="add-location-content" ref={subjectContainerRef}>
                <div className="user-container">
                    <h1>
                        Product <span>*</span>
                    </h1>
                    <div className='user-first-last-div'>
                        <input
                            className={`custome-input`}
                            placeholder={'Product name'}
                            onChange={handleChange}
                            value={productData?.name}
                            id="name"
                        />
                    </div>

                </div>
                <div className="user-container mt-2">
                    {/* <h1>
                        Subjects <span>*</span>
                    </h1> */}

                    <div className='loctaion-title'>
                        <div className='title'>
                            <h2 className='mb-2'>
                            Subjects<span>*</span>
                            </h2>
                        </div>
                        <div className='addd-location' onClick={() => { handleAddSubject() }}>
                            <img src={AddWhiteIcon} />
                        </div>
                    </div>

                    {productData?.subject &&
                        productData.subject.length > 0 &&
                        productData.subject.map((item: any, subjectIndex: number) => {
                            const formattedClasses = item?.classes.map((clas: any) => clas.name);
                            return (
                                <div className='user-first-last-div' key={`subject-${subjectIndex}`}>
                                    <input
                                        className={`custome-input width-50`}
                                        placeholder={'Subject'}
                                        onChange={(e) => handleSubjectChange(e, subjectIndex)} // Handle subject name change
                                        value={item?.name}
                                    />
                                    <div className='user-first-last-div mt-2'>
                                        <TagsInput
                                            className='custome-input unset-height'
                                            value={formattedClasses}
                                            onChange={(classes) => handleClassChange(classes, subjectIndex)} // Handle class name change
                                            inputProps={{ placeholder: 'Enter Class' }}
                                        />
                                    </div>
                                    <div
                        className="dlt-btn"
                        onClick={() => handleDeleteSubject(subjectIndex)}
                      >
                        <img src={Delete} />
                      </div>
                                </div>
                            );
                        })}


                </div>
            </div>
        );
    };

    const validate = () => {
        let errorMessage = '';
        if (
            !productData?.name 
        ) {
            errorMessage = 'Please enter product name';
        }  else if (!productData?.subject || productData.subject.length === 0) {
            errorMessage = 'Please enter at least one subject';
        } 
        else {
            const invalidSubject = productData.subject.find((subject: any) => !subject.name?.trim());
            if (invalidSubject) {
                errorMessage = 'Please enter valid names for all subjects';
            }
        }
        if (errorMessage) {
            showNotification({
                type: 'info',
                title: errorMessage,
            });
            return false;
        }
        return true;
    };
    return (
        <>
            <Modal
                show={open}
                onHide={() => { resetStates(), onClose() }}
                className={`steam-modal-dialog add-product-modal `}
                size="sm"

            >
                <Modal.Header closeButton >
                    <div className="model-header-tab">
                        <div className="modal-header-title">
                            {editProductData ? "Edit Product" : 'Add new product'}
                        </div>
                        <div className="modal-header-desc">
                            {''}
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body >{getContent()}</Modal.Body>
                <ModalFooter>
                    <div className={`btn-container end`}>
                        <button
                            className={`steam-button button-dark set-height-1`}
                            onClick={async () => {
                                if(validate()){
                                    await useProductUpdateMutations.mutateAsync({
                                        id: editProductData ? Number(editProductData?.id) : undefined,
                                        name: productData?.name,
                                        subject: productData?.subject,
                                    });
                                    onConfirm();
                                }

                            }}
                        //disabled={useAddProductMutation?.isLoading}
                        >
                            <span>{editProductData ? "Save" : 'Add Product'}</span>
                        </button>
                    </div>
                </ModalFooter>
            </Modal>
        </>
    );
};




export default EditProduct;
